import React, { useEffect, useState } from "react";
import { useHistory, useLocation, withRouter } from "react-router";
import { makeId } from "../../helpers/func";
import { BASE_URL } from "../../variables/api";
import axios from "axios";
import ImageHighlightComponent from "../questions/ImageHighlightComponent";
import FillTheBlank from "../questions/FillTheBlank";
import FileUploadEnhanced from "../questions/FileUploadEnhanced";
import AudioComponent from "../questions/AudioComponent";
import VideoComponent from "../questions/VideoComponent";
import EssayComponent from "../questions/EssayComponent";
import TrueOrFalse from "../questions/TrueOrFalse";
import LabelQComponent from "../questions/LabelQComponent";
import OrderComponent from "../questions/OrderComponent";
import MCQComponent from "../questions/MCQComponent";
import Swal from "sweetalert2";
import $ from "jquery";
import "../../css/DashBoard.css";
import "../../css/assessment.css";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import Select from "react-select";
import { NavLink } from "react-router-dom";
import ProcessCardSingleState from "../questions/ProcessCardSingleState";
import MatchQComponent from "../questions/MatchQComponent";
import { MathJax } from "better-react-mathjax";

import Passage from "../questions/smallComponents/Passage";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useSelector } from "react-redux";

const difficultLevelMap = {
  "1": "Basic Level",
  "2": "Intermediate Level",
  "3": "Advanced Level",
};

const cognitiveLevelMap = {
  "1": "Remember",
  "2": "Understand",
  "3": "Apply",
  "4": "Analyze",
  "5": "Evaluate",
  "6": "Create",
};

function format(date: any, f: any) {
  const d = new Date(date);
  let month = "" + (d.getMonth() + 1);
  let day = "" + d.getDate();
  const year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

const getToday = () => {
  var now = new Date();
  var offset = now.getTimezoneOffset() * 60000;
  var adjustedDate = new Date(now.getTime() - offset);
  var formattedDate = adjustedDate.toISOString().substring(0, 16); // For minute precision
  return formattedDate;
};
interface MobileQuestionMenuProps {
  onSelect: (type: string) => void;
  issecured?: boolean;
}
const questionTypes = [
  { type: "TrueOrFalse", icon: "fas fa-check-circle", label: "True/False" },
  { type: "MCQ", icon: "fas fa-tasks", label: "Multiple Choice" },
  { type: "MatchQComponent", icon: "fas fa-bars", label: "Matching" },
  { type: "OrderComponent", icon: "fas fa-sort", label: "Ordering" },
  {
    type: "EssayComponent",
    icon: "fas fa-keyboard",
    label: "Short Answer/Essay",
  },
  { type: "AudioComponent", icon: "fas fa-microphone", label: "Audio" },
  { type: "VideoComponent", icon: "fas fa-video", label: "Video" },
  {
    type: "FileUploadEnhanced",
    icon: "fas fa-file-upload",
    label: "File Upload",
  },
  {
    type: "ImageHighlight",
    icon: "fas fa-highlighter",
    label: "Highlight Image",
  },
  {
    type: "ProcessCard",
    icon: "fas fa-chalkboard-user",
    label: "Process Card",
  },
  { type: "ProductCard", icon: "fas fa-robot", label: "Product Card" },
];
const MobileQuestionMenu: React.FC<MobileQuestionMenuProps> = ({
  onSelect,
  issecured,
}) => {
  const [showMenu, setShowMenu] = useState(false);

  return (
    <>
      <div
        className="d-block d-md-none"
        style={{
          position: "fixed",
          right: 30,
          top: window.innerHeight - 100,
          zIndex: 9999,
          width: 60,
          height: 60,
          userSelect: "none",
        }}
      >
        <button
          className="btn btn-primary rounded-circle shadow"
          style={{
            width: 60,
            height: 60,
            fontSize: 30,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => setShowMenu((v) => !v)}
          title="add new question"
        >
          +
        </button>

        {showMenu && (
          <div
            className="card p-2 menu-card"
            style={{
              position: "absolute",
              bottom: 70,
              right: 0,
              minWidth: 220,
              zIndex: 10000,
            }}
          >
            <div className="list-group">
              {questionTypes
                ?.filter((x) => {
                  // Filter out secure-incompatible question types when exam is secured
                  if (issecured === true) {
                    return !(
                      x.type === "FileUploadEnhanced" ||
                      x.type === "ImageHighlight" ||
                      x.type === "ProcessCard" ||
                      x.type === "ProductCard" ||
                      x.type === "AudioComponent" ||
                      x.type === "VideoComponent"
                    );
                  }
                  return true;
                })
                .map((q) => (
                  <div
                    key={q.type}
                    className="list-group-item"
                    style={{ padding: "10px 15px", cursor: "pointer" }}
                    onClick={() => {
                      onSelect(q.type);
                      setShowMenu(false);
                    }}
                  >
                    <i className={q.icon} style={{ marginRight: 10 }} />
                    {q.label}
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
};
const assessmentComponent = () => {
  const location = useLocation();
  const history = useHistory();

  // mapDispatchToProps
  const user = useSelector((storeState: any) => storeState.user);

  const AddAssessment = (data: any) => {
    Swal.showLoading();

    if (!state.name) {
      Swal.fire("Title is required", "", "error");
      return;
    }

    if (Number(data.istimed) && Number(data.istimed) !== 0) {
      let stringDuration = String(data.duration);
      if (
        stringDuration.startsWith("-") ||
        stringDuration.includes(".") ||
        stringDuration.startsWith("0") ||
        Number(data.duration) <= 0
      ) {
        Swal.fire({
          icon: "error",
          title: "Invalid Duration",
          text: "Please enter a valid positive integer for duration.",
        });
        return;
      }
    }

    if (user.isExternalUser) {
      axios
        .post(`${BASE_URL}externaluser/addexam.php`, data)
        .then((res: any) => {
          Swal.fire({
            title: "Added Successfully",
            icon: "success",
            didOpen: () => {
              const okButton = Swal.getConfirmButton();
              if (okButton) {
                okButton.id = "okButtonId"; // ✅ Set your custom ID here
              }
            },
          }).then((x: any) => {
            onConfirm(res.data.data.exam?.id);
          });
        })
        .catch((error: any) => {
          Swal.fire(
            "Something went wrong , please check the internent and try again ",
            "",
            "error"
          );
        });
    } else {
      axios
        .post(`${BASE_URL}admin/addexam.php`, data)
        .then((res: any) => {
          Swal.fire({
            title: "Added Successfully",
            icon: "success",
            didOpen: () => {
              const okButton = Swal.getConfirmButton();
              if (okButton) {
                okButton.id = "okButtonId"; // ✅ Set your custom ID here
              }
            },
          }).then((x: any) => {
            onConfirm(res.data.data.exam.id);
          });
        })
        .catch((error: any) => {
          Swal.fire(
            "Something went wrong , please check the internent and try again ",
            "",
            "error"
          );
        });
    }
  };

  const loading = () => {
    Swal.fire({
      html: '<div style="color:blue;"> Loading....... </div>',
      showConfirmButton: false,
    });
  };
  const DeletePassage = (id: any) => {
    Swal.fire({
      title: "Are you sure to delete this passage?",
      text: "Please note that this action cannot be undone.?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then((x) => {
      if (x.isConfirmed) {
        loading();
        axios
          .post(BASE_URL + `admin/deletepassage.php`, { passage_id: id })
          .then((res) => {
            Swal.fire({
              title: "success",
              text: "Deleted successfully",
              icon: "success",
              confirmButtonText: "Okay",
            });
            let tempPassages = [
              ...state.passages?.filter((p: any) => p.id != id),
            ];
            let temp_all_selected_passages_questions: any = [];
            tempPassages.forEach((passage: any) => {
              if (passage.selectedQuestions)
                temp_all_selected_passages_questions = [
                  ...passage.selectedQuestions,
                ];
            });

            setState((prev: any) => ({
              ...prev,
              passages: tempPassages,
              all_selected_passages_questions:
                temp_all_selected_passages_questions,
            }));
          })
          .catch((err) => {
            Swal.fire(err.response.data.msg, "", "error");
          });
      }
    });
  };
  const DeleteQuestion = (id: any) => {
    Swal.fire({
      title: "Are you sure to delete this question?",
      text: "Please note that this action cannot be undone.?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then((x) => {
      if (x.isConfirmed) {
        loading();
        axios
          .post(BASE_URL + `admin/deletequestion.php`, { question_id: id })
          .then((res) => {
            Swal.fire({
              title: "success",
              text: "Deleted successfully",
              icon: "success",
              confirmButtonText: "Okay",
            });
            let tempQuestions = [...state.questions];
            setState((prev: any) => ({
              ...prev,
              questions: [...tempQuestions.filter((q: any) => q.id != id)],
            }));
          })
          .catch((err) => {
            Swal.fire(err.response.data.msg, "", "error");
          });
      }
    });
  };

  const GetAssessment = (id: any, version: any) => {
    let exam_path = "admin/getexam.php";

    axios
      .post(`${BASE_URL}${exam_path}`, {
        id: id,
        version,
      })
      .then((res: any) => {
        if (isAi == "true") {
          let questions: any = [];
          let exam_from_local_storage = localStorage.getItem("exam_questions");
          if (exam_from_local_storage) {
            let exam = JSON.parse(exam_from_local_storage);

            if (exam.id == id) questions = exam?.questions;
          }
          setState((prev: any) => ({
            ...prev,
            ...res.data.data,
            questions: questions,
          }));
        } else {
          let exam = { ...res.data.data };
          let temp_all_selected_passages_questions: any = [];
          exam.passages?.forEach((passage: any) => {
            passage.selectedQuestions = exam.questions
              .filter((q: any) => q.passage_id == passage.id)
              ?.map((q: any) => {
                return {
                  label: `${htmlToText(q.header).substring(0, 200)}`,
                  value: q.id,
                };
              });

            temp_all_selected_passages_questions.push(
              ...passage.selectedQuestions
            );
          });

          setState((prev: any) => ({
            ...prev,
            ...exam,
            all_selected_passages_questions:
              temp_all_selected_passages_questions,
          }));
        }
        SetCourseUtils((prev: any) => ({
          ...prev,
          coursestandards: res.data.data.coursestandards,
        }));
        GetCategoriesTeachersPeriods(res.data.data.coursegroup_id);
      })
      .catch((err: any) => {
        Swal.fire(
          "Something went wrong , please check the internent and refresh the page ",
          err.response.data.msg,
          "error"
        );
      });
  };
  const UpdateAssessment = (data: any) => {
    Swal.showLoading();

    if (Number(data.istimed) && Number(data.istimed) !== 0) {
      let stringDuration = String(data.duration);
      if (
        stringDuration.startsWith("-") ||
        stringDuration.includes(".") ||
        stringDuration.startsWith("0") ||
        Number(data.duration) <= 0
      ) {
        Swal.fire({
          icon: "error",
          title: "Invalid Duration",
          text: "Please enter a valid positive integer for duration.",
        });
        return;
      }
    }
    if (user.isExternalUser) {
      axios
        .post(`${BASE_URL}externaluser/admin/updateexam.php`, {
          ...data,
          id: examId,
          version,
        })
        .then((res: any) => {
          Swal.fire({
            title: "Updated Successfully",
            icon: "success",
            didOpen: () => {
              const okButton = Swal.getConfirmButton();
              if (okButton) {
                okButton.id = "okButtonId"; // ✅ Set your custom ID here
              }
            },
          }).then((x: any) => {
            onConfirm(examId);
          });
        })
        .catch((error: any) => {
          Swal.fire(
            "Something went wrong please check the internent and try again ",
            "",
            "error"
          );
        });
    } else {
      axios
        .post(`${BASE_URL}admin/updateexam.php`, {
          ...data,
          id: examId,
          version,
        })
        .then((res: any) => {
          Swal.fire({
            title: "Updated Successfully",
            icon: "success",
            didOpen: () => {
              const okButton = Swal.getConfirmButton();
              if (okButton) {
                okButton.id = "okButtonId"; // ✅ Set your custom ID here
              }
            },
          }).then((x: any) => {
            onConfirm(examId);
          });
        })
        .catch((error: any) => {
          Swal.fire(
            "Something went wrong please check the internent and try again ",
            "",
            "error"
          );
        });
    }
  };

  const onDrop = (source: any, destination: any) => {
    let tempQuestions = [...state.questions];
    tempQuestions.splice(destination, 0, tempQuestions.splice(source, 1)[0]);
    tempQuestions.forEach((q: any, index: any) => {
      q.qorder = index + 1;
    });
    setState((prev: any) => ({
      ...prev,
      questions: tempQuestions,
    }));
  };

  const GetCategoriesTeachersPeriods = (id: any) => {
    Swal.showLoading();
    axios
      .get(`${BASE_URL}admin/get_teachers_periods_categories.php?id=${id}`)
      .then((res: any) => {
        SetCourseUtils({
          teachers: res.data.data.teachers?.map((teacher: any) => {
            return {
              value: teacher.id,
              label: teacher.displayname,
              username: teacher.officialemail?.toLowerCase(),
            };
          }),
          periods: res.data.data.periods,
          categories: res.data.data.categories,
          coursestandards: res.data.data.coursestandards,
        });
        if (!examId || examId == "null") {
          setState((prev: any) => ({
            ...prev,
            selectedteachers: res.data.data.teachers?.map((teacher: any) => {
              return {
                value: teacher.id,
                label: teacher.displayname,
                username: teacher.officialemail?.toLowerCase(),
              };
            }),
          }));
        }
        Swal.close();
      })
      .catch((err) => {
        Swal.close();
        Swal.fire(
          "Something went wrong , please check the internent and try again ",
          "",
          "error"
        );
      });
  };

  const searchParams: any = new URLSearchParams(location.search);
  const examId = searchParams.get("id");
  const version = searchParams.get("v");
  const isAi = searchParams.get("isAi");
  const groupId = searchParams.get("course_id");
  const categoryId = searchParams.get("category_id");
  const copy_assessment = searchParams.get("copy");
  const periodId = searchParams.get("period_id");
  const assesmentTitle = searchParams.get("assessment_title");
  const assessment_prefix = assesmentTitle?.split("-")[0];
  const assessment_type = assesmentTitle?.split("-")[2];
  const sequance = assesmentTitle?.split("-")[3];
  const number_of_trials = assesmentTitle?.split("-")[4];

  // mapStateToProps

  let date = new Date();
  const [state, setState] = useState<any>({
    id: makeId(10),
    name: assesmentTitle,
    grade: "",
    type: "",
    etype: "regular",
    course: "",
    gradingcategoryid: categoryId,
    gradingperiodid: periodId,
    sequance: "",
    number_of_trials: "",
    assessment_type: "",
    assessment_prefix: "",
    returnResultTo: "",
    passages: [],
    startdate:
      format(new Date(), "yyyy-MM-dd") +
      "T" +
      new Date().toLocaleString()?.split(", ")[1],
    enddate:
      format(date.setDate(new Date().getDate() + 1), "yyyy-MM-dd") +
      "T" +
      new Date().toLocaleString()?.split(", ")[1],
    nooftrials: 1,
    courses: [],
    teachers: [],
    coursegroup_id: groupId,
    teacherids: [],
    grading_teachers_ids: {},
    editing_teachers_ids: {},
    submitalert: false,
    periods: [],
    questions: [],
    open: false,
    selectedgroups: [],
    selectedteachers: [],
    weeknumber: 1,
    istimed: 0,
    issecured: 0,
    isprivate: 0,
    ismandatory: 0,
    duration: 0,
    categories: [],
    all_selected_passages_questions: [],
  });

  // karim stats
  const [modalContent, setModalContent] = useState<any>(null);
  const [showAdvancedOptions, setShowAdvancedOptions] =
    useState<boolean>(false);
  const [CourseUtils, SetCourseUtils] = useState<any>({
    teachers: [],
    periods: [],
    categories: [],
    coursestandards: [],
  });

  const GetCourses = () => {
    axios.post(BASE_URL + "admin/getcourses.php", {}).then((res: any) => {
      setState((x: any) => ({ ...x, courses: res.data.data }));
    });
  };

  useEffect(() => {
    let assessment: any = null;
    if (examId && examId != "null") {
      GetAssessment(examId, version);
      GetCourses();
      $("#preloader").hide();
      assessment = assessment;
      if (assessment == null) {
        return;
      }
    } else {
      $("#preloader").hide();
    }
    if (assessment != null && groupId === undefined) {
      GetCourses();
      // Swal.fire({
      //   text: JSON.stringify(assessment.course?.coursegroup_id)
      // });

      // return;
      GetCategoriesTeachersPeriods(assessment.course?.coursegroup_id);
    } else {
      // in case Add

      GetCourses();
      let date = new Date();
      if (groupId === undefined) {
        setState((prevState: any) => ({
          ...prevState,
          startdate:
            format(new Date(), "yyyy-MM-dd") +
            "T" +
            new Date().toLocaleString()?.split(", ")[1],
          enddate:
            format(date.setDate(new Date().getDate() + 1), "yyyy-MM-dd") +
            "T" +
            new Date().toLocaleString()?.split(", ")[1],

          teacherids: [],
          teachers: [],
        }));
      } else {
        GetCategoriesTeachersPeriods(groupId);
      }
    }
  }, []);

  // Update window.questionsPayload whenever questions change
  useEffect(() => {
    (window as any).questionsPayload = state.questions;
    // console.log("questionsPayload updated:", (window as any).questionsPayload);
  }, [state.questions]);

  const onCloseModal = (Q: any = null) => {
    // save q in array in the store
    setState((x: any) => ({ ...x, open: false }));
    // setState({ open: false });
  };
  const onOpenPassageModal = (passage: any = null) => {
    setModalContent(
      <Passage
        passage={passage}
        mode="editingMode"
        onCloseModal={() => {
          onCloseModal();
        }}
        onSavePassage={(passage: any) => {
          onSavePassage(passage);
        }}
      />
    );
    setState((x: any) => ({ ...x, open: true }));
  };

  const onSavePassage = (passage: any) => {
    let tempPassages = [...state.passages];
    let foundPassageIndex = tempPassages.findIndex((p) => p.id == passage.id);
    if (foundPassageIndex != -1) {
      tempPassages[foundPassageIndex] = passage;
    } else {
      tempPassages.push(passage);
    }

    setState((x: any) => ({ ...x, open: false, passages: tempPassages }));
  };

  const onSaveQuestion = (question: any) => {
    let tempQuestins = [...state.questions];
    let q = tempQuestins.find((q: any) => q.id == question.id);
    let updatedQuestions: any[];

    if (q) {
      let questions = [...state.questions];
      let index = questions.indexOf(q);

      question.qorder = index + 1;
      questions[index] = question;
      updatedQuestions = questions;
      setState((prev: any) => ({ ...prev, questions: questions }));
    } else {
      question.qorder = tempQuestins.length + 1;
      updatedQuestions = tempQuestins.concat(question);
      setState((prev: any) => ({
        ...prev,
        questions: updatedQuestions,
      }));
    }

    onCloseModal();
  };

  const submitExam = () => {
    // const {
    //     selectedgroups,
    // } = state;

    const data: any = {
      sequance,
      number_of_trials,
      assessment_type,
      assessment_prefix,
      questions: state.questions,
      teacherids: state.selectedteachers,
      courses: [],
      coursegroup_id: state.coursegroup_id,
      teachers: state.selectedteachers,
    };

    const state_props = [
      "id",
      "name",
      "grade",
      "type",
      "startdate",
      "enddate",
      "nooftrials",
      "course",
      "gradingperiodid",
      "etype",
      "sequance",
      "number_of_trials",
      "assessment_type",
      "assessment_prefix",
      "gradingcategoryid",
      "selectedteachers",
      "weeknumber",
      "istimed",
      "ismandatory",
      "issecured",
      "isprivate",
      "duration",
      "questions",
      "passages",
      "returnResultTo",
    ];
    state_props.forEach((state_prop: string) => {
      if (state.hasOwnProperty(state_prop)) {
        data[state_prop] = state[state_prop];
      }
    });

    if (
      copy_assessment == 1 ||
      examId == null ||
      examId == "null" ||
      examId == undefined
    ) {
      AddAssessment(data);
    } else {
      UpdateAssessment(data);
    }
  };

  const removeQuest = (e: any) => {
    DeleteQuestion(e.id);
  };

  const QuestionsRenderer = (q: any) => {
    // console.log(state);

    // if (!state.coursegroup_id && !user.isExternalUser) {
    //   Swal.fire({
    //     title: "Course Required",
    //     text: "Please select a course first",
    //     icon: "error",
    //     confirmButtonText: "OK",
    //   }).then(() => {
    //     onCloseModal();
    //   });
    //   return;
    // }
    switch (q) {
      case "MCQ":
        setModalContent(
          <MCQComponent
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
            coursestandards={CourseUtils.coursestandards}
            course_standards_targets={state.course_standards_targets?.filter(
              (target: any) => target.standard_id == q.standardid
            )}
          />
        );
        return;
      case "OrderComponent":
        setModalContent(
          <OrderComponent
            coursestandards={CourseUtils.coursestandards}
            course_standards_targets={state.course_standards_targets?.filter(
              (target: any) => target.standard_id == q.standardid
            )}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );
        return;
      case "MatchQComponent":
        setModalContent(
          <MatchQComponent
            coursestandards={CourseUtils.coursestandards}
            course_standards_targets={state.course_standards_targets?.filter(
              (target: any) => target.standard_id == q.standardid
            )}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );
        return;
      case "ProcessCard":
        setModalContent(
          <ProcessCardSingleState
            type={"ProcessCard"}
            coursestandards={CourseUtils.coursestandards}
            course_standards_targets={state.course_standards_targets?.filter(
              (target: any) => target.standard_id == q.standardid
            )}
            onCloseModal={() => onCloseModal()}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );
        return;
      case "ProductCard":
        setModalContent(
          <ProcessCardSingleState
            type={"ProductCard"}
            coursestandards={CourseUtils.coursestandards}
            course_standards_targets={state.course_standards_targets?.filter(
              (target: any) => target.standard_id == q.standardid
            )}
            onCloseModal={() => onCloseModal()}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );
        return;
      case "LabelQComponent":
        setModalContent(
          <LabelQComponent
            coursestandards={CourseUtils.coursestandards}
            course_standards_targets={state.course_standards_targets?.filter(
              (target: any) => target.standard_id == q.standardid
            )}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );
        return;
      case "TrueOrFalse":
        setModalContent(
          <TrueOrFalse
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
            course_standards_targets={state.course_standards_targets?.filter(
              (target: any) => target.standard_id == q.standardid
            )}
            coursestandards={CourseUtils.coursestandards}
          />
        );
        return;
      case "EssayComponent":
        setModalContent(
          <EssayComponent
            coursestandards={CourseUtils.coursestandards}
            course_standards_targets={state.course_standards_targets?.filter(
              (target: any) => target.standard_id == q.standardid
            )}
            etype={state.etype}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );
        return;
      case "VideoComponent":
        setModalContent(
          <VideoComponent
            coursestandards={CourseUtils.coursestandards}
            course_standards_targets={state.course_standards_targets?.filter(
              (target: any) => target.standard_id == q.standardid
            )}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );
        return;
      case "AudioComponent":
        setModalContent(
          <AudioComponent
            coursestandards={CourseUtils.coursestandards}
            course_standards_targets={state.course_standards_targets?.filter(
              (target: any) => target.standard_id == q.standardid
            )}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );
        return;
      case "FileUploadEnhanced":
        setModalContent(
          <FileUploadEnhanced
            coursestandards={CourseUtils.coursestandards}
            course_standards_targets={state.course_standards_targets?.filter(
              (target: any) => target.standard_id == q.standardid
            )}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );
        return;
      case "FillTheBlank":
        setModalContent(
          <FillTheBlank
            coursestandards={CourseUtils.coursestandards}
            course_standards_targets={state.course_standards_targets?.filter(
              (target: any) => target.standard_id == q.standardid
            )}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );
        return;
      case "ImageHighlight":
        setModalContent(
          <ImageHighlightComponent
            coursestandards={CourseUtils.coursestandards}
            course_standards_targets={state.course_standards_targets?.filter(
              (target: any) => target.standard_id == q.standardid
            )}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );
        return;
      default:
        return (
          <h1>
            Select Question Type From The Left Menu To Add It To The Assessment
          </h1>
        );
    }
  };

  const handlecourseselect = (selectedoptions: any) => {
    // Swal.fire({
    //   title: "Course Selected",
    //   html: `<pre>${JSON.stringify(selectedoptions, null, 2)}</pre>`,
    //   icon: "info",
    // });
    // return;

    GetCategoriesTeachersPeriods(selectedoptions.value);

    setState((prev: any) => ({
      ...prev,
      coursegroup_id: selectedoptions.value,
    }));
  };

  const editQuestionsRenderer = (s: any, q: any) => {
    switch (s) {
      case "MCQ":
        setModalContent(
          <MCQComponent
            course_standards_targets={state.course_standards_targets?.filter(
              (target: any) => target.standard_id == q.standardid
            )}
            coursestandards={CourseUtils.coursestandards}
            quest={q}
            onCloseModal={() => onCloseModal()}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );
        return null;
      case "OrderComponent":
        setModalContent(
          <OrderComponent
            course_standards_targets={state.course_standards_targets?.filter(
              (target: any) => target.standard_id == q.standardid
            )}
            coursestandards={CourseUtils.coursestandards}
            quest={q}
            onCloseModal={() => onCloseModal()}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );
        return null;
      case "MatchQComponent":
        setModalContent(
          <MatchQComponent
            course_standards_targets={state.course_standards_targets?.filter(
              (target: any) => target.standard_id == q.standardid
            )}
            coursestandards={CourseUtils.coursestandards}
            quest={q}
            onCloseModal={() => onCloseModal()}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );
        return null;
      case "ProcessCard":
        setModalContent(
          <ProcessCardSingleState
            course_standards_targets={state.course_standards_targets?.filter(
              (target: any) => target.standard_id == q.standardid
            )}
            coursestandards={CourseUtils.coursestandards}
            type={"ProcessCard"}
            quest={q}
            onCloseModal={() => onCloseModal()}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );
        return null;
      case "ProductCard":
        setModalContent(
          <ProcessCardSingleState
            course_standards_targets={state.course_standards_targets?.filter(
              (target: any) => target.standard_id == q.standardid
            )}
            coursestandards={CourseUtils.coursestandards}
            type={"ProductCard"}
            quest={q}
            onCloseModal={() => onCloseModal()}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );
        return null;
      case "LabelQComponent":
        setModalContent(
          <LabelQComponent
            course_standards_targets={state.course_standards_targets?.filter(
              (target: any) => target.standard_id == q.standardid
            )}
            coursestandards={CourseUtils.coursestandards}
            quest={q}
            onCloseModal={() => onCloseModal()}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );
        return null;
      case "TrueOrFalse":
        setModalContent(
          <TrueOrFalse
            course_standards_targets={state.course_standards_targets?.filter(
              (target: any) => target.standard_id == q.standardid
            )}
            coursestandards={CourseUtils.coursestandards}
            quest={q}
            onCloseModal={() => onCloseModal()}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );
        return null;
      case "EssayComponent":
        setModalContent(
          <EssayComponent
            course_standards_targets={state.course_standards_targets?.filter(
              (target: any) => target.standard_id == q.standardid
            )}
            coursestandards={CourseUtils.coursestandards}
            quest={q}
            etype={state.etype}
            onCloseModal={() => onCloseModal()}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );
        return null;
      case "VideoComponent":
        setModalContent(
          <VideoComponent
            course_standards_targets={state.course_standards_targets?.filter(
              (target: any) => target.standard_id == q.standardid
            )}
            coursestandards={CourseUtils.coursestandards}
            quest={q}
            onCloseModal={() => onCloseModal()}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );
        return null;
      case "AudioComponent":
        setModalContent(
          <AudioComponent
            course_standards_targets={state.course_standards_targets?.filter(
              (target: any) => target.standard_id == q.standardid
            )}
            coursestandards={CourseUtils.coursestandards}
            quest={q}
            onCloseModal={() => onCloseModal()}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );
        return null;
      case "FileUploadEnhanced":
        setModalContent(
          <FileUploadEnhanced
            course_standards_targets={state.course_standards_targets?.filter(
              (target: any) => target.standard_id == q.standardid
            )}
            coursestandards={CourseUtils.coursestandards}
            quest={q}
            onCloseModal={() => onCloseModal()}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );
        return null;
      case "FillTheBlank":
        setModalContent(
          <FillTheBlank
            quest={q}
            onCloseModal={() => onCloseModal()}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );
        return null;
      case "ImageHighlight":
        setModalContent(
          <ImageHighlightComponent
            course_standards_targets={state.course_standards_targets?.filter(
              (target: any) => target.standard_id == q.standardid
            )}
            coursestandards={CourseUtils.coursestandards}
            quest={q}
            onCloseModal={() => onCloseModal()}
            onSaveQuestion={(q: any) => onSaveQuestion(q)}
          />
        );
        return null;
      default:
        return (
          <h1>
            Select Question Type From The Left Menu To Add It To The Assessment
          </h1>
        );
    }
  };
  const onConfirm = (exam_id: any) => {
    if (user.isExternalUser) {
    } else {
      history.push(`/dashboard/assessments/${exam_id}`);
    }
  };

  const htmlToText = (html: any) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };
  return (
    <MathJax>
      <div className="">
        <div>
          <div className=" d-flex d-md-block flex-nowrap wrapper ">
            <div
              className="col-md-2 float-left pl-0 pr-0 collapse width show"
              id="sidebar"
              style={{
                height: "calc(100vh -1px)",
              }}
            >
              <div className="list-group border-0 card text-center text-md-left d-none d-md-block">
                <div
                  className="list-group-item pointer  d-inline-block collapsed w-100 text-left"
                  data-parent="#sidebar"
                  onClick={() => {
                    QuestionsRenderer("TrueOrFalse");
                    setState((x: any) => ({ ...x, open: true }));
                    // setState({ open: true });
                  }}
                >
                  <i
                    className="fas fa-check-circle"
                    style={{ marginRight: "2px" }}
                    aria-hidden="true"
                  ></i>
                  <i className="fas fa-times-circle" aria-hidden="true"></i>
                  <span className="d-none d-lg-inline">+ True/False </span>
                </div>
                <div
                  className="list-group-item pointer w-100 text-left d-inline-block collapsed"
                  data-parent="#sidebar"
                  onClick={() => {
                    QuestionsRenderer("MCQ");

                    setState((x: any) => ({ ...x, open: true }));
                    // setState({ open: true });
                  }}
                >
                  <i className="fas fa-tasks"></i>{" "}
                  <span className="d-none d-lg-inline">+ Multiple Choice </span>
                </div>
                <div
                  className="list-group-item pointer w-100 text-left d-inline-block collapsed"
                  data-parent="#sidebar"
                  onClick={() => {
                    QuestionsRenderer("MatchQComponent");
                    setState((x: any) => ({ ...x, open: true }));
                    // setState({
                    //     open: true,
                    // });
                  }}
                >
                  <i className="fas fa-bars"></i>{" "}
                  <span className="d-none d-lg-inline">+ Matching </span>
                </div>
                <div
                  className="list-group-item pointer w-100 text-left d-inline-block collapsed"
                  data-parent="#sidebar"
                  onClick={() => {
                    QuestionsRenderer("OrderComponent");
                    setState((x: any) => ({ ...x, open: true }));
                    // setState({ open: true });
                  }}
                >
                  <i className="fas fa-sort"></i>{" "}
                  <span className="d-none d-lg-inline">+ Ordering </span>
                </div>

                <div
                  className="list-group-item pointer w-100 text-left d-inline-block collapsed"
                  data-parent="#sidebar"
                  onClick={() => {
                    QuestionsRenderer("EssayComponent");
                    // setState({ open: true });
                    setState((x: any) => ({ ...x, open: true }));
                  }}
                >
                  <i className="fas fa-keyboard"></i>{" "}
                  <span className="d-none d-lg-inline">
                    + Short Answer/Essay
                  </span>
                </div>

                {state.issecured == 0 ? (
                  <>
                    <div
                      className="list-group-item pointer w-100 text-left d-inline-block collapsed"
                      data-parent="#sidebar"
                      onClick={() => {
                        QuestionsRenderer("AudioComponent");
                        // setState({ open: true });
                        setState((x: any) => ({ ...x, open: true }));
                      }}
                    >
                      <i className="fas fa-microphone"></i>{" "}
                      <span className="d-none d-lg-inline">+ Audio</span>
                    </div>
                    <div
                      className="list-group-item pointer w-100 text-left d-inline-block collapsed"
                      data-parent="#sidebar"
                      onClick={() => {
                        QuestionsRenderer("VideoComponent");
                        // setState({ open: true });
                        setState((x: any) => ({ ...x, open: true }));
                      }}
                    >
                      <i className="fas fa-video"></i>{" "}
                      <span className="d-none d-lg-inline">+ Video</span>
                    </div>
                    <div
                      className="list-group-item pointer w-100 text-left d-inline-block collapsed"
                      data-parent="#sidebar"
                      onClick={() => {
                        QuestionsRenderer("FileUploadEnhanced");
                        // setState({ open: true });
                        setState((x: any) => ({ ...x, open: true }));
                      }}
                    >
                      <i className="fas fa-file-upload"></i>{" "}
                      <span className="d-none d-lg-inline">+ File Upload</span>
                    </div>

                    <div
                      className="list-group-item pointer w-100 text-left d-inline-block collapsed"
                      data-parent="#sidebar"
                      onClick={() => {
                        QuestionsRenderer("ImageHighlight");
                        // setState({ open: true });
                        setState((x: any) => ({ ...x, open: true }));
                      }}
                    >
                      <i className="fas fa-highlighter"></i>{" "}
                      <span className="d-none d-lg-inline">
                        + Highlight Image
                      </span>
                    </div>

                    <div
                      className="list-group-item pointer w-100 text-left d-inline-block collapsed"
                      data-parent="#sidebar"
                      onClick={() => {
                        QuestionsRenderer("ProcessCard");
                        setState((x: any) => ({ ...x, open: true }));
                      }}
                    >
                      <i className="fas fa-solid fa-chalkboard-user"></i>{" "}
                      <span className="d-none d-lg-inline">+ Process Card</span>
                    </div>

                    <div
                      className="list-group-item pointer w-100 text-left d-inline-block collapsed"
                      data-parent="#sidebar"
                      onClick={() => {
                        QuestionsRenderer("ProductCard");
                        setState((x: any) => ({ ...x, open: true }));
                      }}
                    >
                      <i className="fas fa-solid fa-robot"></i>{" "}
                      <span className="d-none d-lg-inline">+ Product Card</span>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div
              className="col-md-10 col-12 float-left mx-auto pl-md-2 pt-2 main"
              style={{
                marginTop: "-8px",
              }}
            >
              <div>
                <div
                  className="col-12 mx-auto bg-question rounded shadow-lg  text-white"
                  style={{
                    height: "calc(100vh - 1px)",
                    overflowY: "auto",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {/* Fixed Header Section */}
                  <div
                    className="p-3 border-bottom border-secondary"
                    style={{ flexShrink: 0 }}
                  >
                    <button
                      title="go back"
                      onClick={() => {
                        history.goBack();
                      }}
                      className="btn btn-secondary mb-3"
                      id="backbuttonID"
                    >
                      <i
                        className="fa fa-arrow-left"
                        aria-hidden="true"
                        id="backbuttonID"
                      />
                    </button>
                    <h3 className="text-shadow mb-0">Assessment Setup</h3>
                  </div>

                  {/* Scrollable Content Section */}
                  <div className="flex-grow-1 p-3" style={{ overflow: "auto" }}>
                    <div className="row">
                      <div className="col-md-4 mt-2 row align-items-start align-content-start mx-auto">
                        <label
                          className="align-self-start ml-1 "
                          htmlFor="title"
                        >
                          Title: &nbsp;
                        </label>
                        <input
                          id="title"
                          name="title"
                          type="text"
                          disabled={assesmentTitle ? true : false}
                          className="form-control"
                          value={state?.name || ""}
                          onChange={(e) => {
                            // setState({ name: e.target.value });
                            const new_name = e?.target?.value;

                            setState((x: any) => ({ ...x, name: new_name }));
                          }}
                        />
                      </div>

                      {user?.isExternalUser ? (
                        ""
                      ) : (
                        <div className="col-md-4 mt-2 align-items-start align-content-start mx-auto">
                          <label
                            className="align-self-start ml-1 mt-1"
                            htmlFor="course_id"
                          >
                            Course: &nbsp;
                          </label>
                          {
                            <Select
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                              name="selectedcourse"
                              options={state.courses?.map((course: any) => {
                                return {
                                  value: course.coursegroup_id,
                                  label: course.name,
                                };
                              })}
                              className="basic-multi-select text-dark"
                              classNamePrefix="select"
                              value={state.courses
                                ?.map((course: any) => {
                                  //                                 Swal.fire({
                                  //                                   text: `Course Selected: ${JSON.stringify(course)}`,
                                  //                                 });

                                  // return;
                                  return {
                                    value: course.coursegroup_id,
                                    label: course.name,
                                  };
                                })
                                ?.filter(
                                  (op: { value: any; label: any }) =>
                                    op?.value == state.coursegroup_id
                                )}
                              onChange={(e) => {
                                if (e) {
                                  handlecourseselect(e);
                                }
                              }}
                            />
                          }
                        </div>
                      )}

                      <div className="col-md-4 mt-2 row align-items-start align-content-start mx-auto">
                        <label
                          className="align-self-start ml-1 mt-1"
                          htmlFor="startDate"
                        >
                          Start date: &nbsp;
                        </label>
                        <input
                          id="startDate"
                          name="startDate"
                          type="datetime-local"
                          className="form-control"
                          value={state?.startdate ?? getToday()}
                          onChange={(e) =>
                            // setState({ startdate: e.target.value })
                            {
                              const new_startdate = e?.target?.value;
                              if (new_startdate) {
                                setState((x: any) => ({
                                  ...x,
                                  startdate: new_startdate,
                                }));
                              }
                            }
                          }
                        />
                      </div>

                      <div className="col-md-4 mt-2 row align-items-start align-content-start mx-auto">
                        <label
                          className="align-self-start ml-1 mt-1"
                          htmlFor="endDate"
                        >
                          End date: &nbsp;
                        </label>
                        <input
                          id="endDate"
                          name="endDate"
                          type="datetime-local"
                          className="form-control"
                          value={state.enddate || ""}
                          onChange={(e) =>
                            // setState({ enddate: e.target.value })
                            // setState((x: any) => ({ ...x, enddate: e.target.value }))
                            {
                              const new_enddate = e?.target?.value;
                              if (new_enddate) {
                                setState((x: any) => ({
                                  ...x,
                                  enddate: new_enddate,
                                }));
                              }
                            }
                          }
                        />
                      </div>

                      {!user.isExternalUser && (
                        <>
                          <div className="col-md-4 mt-2 align-items-start align-content-start mx-auto">
                            <label
                              className="align-self-start mt-1 ml-1"
                              htmlFor="selectedteachers"
                            >
                              Assigned teachers: &nbsp;
                            </label>
                            {
                              <Select
                                isMulti
                                name="selectedteachers"
                                options={CourseUtils.teachers}
                                className="basic-multi-select text-dark"
                                classNamePrefix="select"
                                value={state.selectedteachers}
                                onChange={(e) => {
                                  // setState({ selectedteachers: e });
                                  if (e) {
                                    setState((x: any) => ({
                                      ...x,
                                      selectedteachers: e,
                                    }));
                                  } else {
                                    setState((x: any) => ({
                                      ...x,
                                      selectedteachers: [],
                                    }));
                                  }
                                }}
                              />
                            }
                          </div>

                          <div className="col-md-4 mt-1 align-items-start align-content-start mx-auto">
                            <label
                              className="align-self-start mt-1 ml-1"
                              htmlFor="selectedgroups"
                            >
                              Grading Category: &nbsp;
                            </label>

                            <Select
                              name="selectedteachers"
                              options={CourseUtils.categories?.map(
                                (cat: any) => {
                                  return {
                                    value: cat.id,
                                    label: cat.name,
                                  };
                                }
                              )}
                              value={CourseUtils?.categories
                                ?.map((cat: any) => {
                                  return {
                                    value: cat.id,
                                    label: cat.name,
                                  };
                                })
                                ?.filter(
                                  (op: any) =>
                                    op.value === state.gradingcategoryid
                                )}
                              onChange={
                                (e) =>
                                  // setState({ gradingcategoryid: e?.value })
                                  {
                                    const new_gradingcategoryid = e?.value;
                                    if (new_gradingcategoryid) {
                                      setState((x: any) => ({
                                        ...x,
                                        gradingcategoryid:
                                          new_gradingcategoryid,
                                      }));
                                    }
                                  }
                                // setState((x: any) => ({ ...x, gradingcategoryid: e?.value }))
                              }
                              className="basic-multi-select text-dark"
                              classNamePrefix="select"
                            />
                          </div>
                          <div className="col-md-4 mt-1 align-items-start align-content-start mx-auto">
                            <label
                              className="align-self-start mt-1 ml-1"
                              htmlFor="selectedgroups"
                            >
                              Grading Period: &nbsp;
                            </label>

                            <Select
                              name="selectedteachers"
                              options={CourseUtils.periods?.map(
                                (period: any) => {
                                  return {
                                    value: period.id,
                                    label: period.name,
                                  };
                                }
                              )}
                              isDisabled={assesmentTitle ? true : false}
                              className="basic-multi-select text-dark"
                              classNamePrefix="select"
                              value={CourseUtils.periods
                                ?.map((period: any) => {
                                  return {
                                    value: period.id,
                                    label: period.name,
                                  };
                                })
                                ?.filter(
                                  (op: { value: any; label: any }) =>
                                    op.value === state.gradingperiodid
                                )}
                              onChange={
                                (e) =>
                                  // setState((x: any) => ({ ...x, gradingperiodid: e?.value }))
                                  {
                                    const new_gradingperiodid = e?.value;
                                    if (new_gradingperiodid) {
                                      setState((x: any) => ({
                                        ...x,
                                        gradingperiodid: new_gradingperiodid,
                                      }));
                                    }
                                  }
                                // setState((x: any) => ({ ...x, gradingperiodid: e?.value }))
                              }
                            />
                          </div>
                          <div className="col-md-4 mt-1 align-items-start align-content-start mx-auto">
                            <label
                              className="align-self-start mt-1 ml-1"
                              htmlFor="selectedgroups"
                            >
                              Exam type : &nbsp;
                            </label>

                            <select
                              disabled={
                                state.questions.length > 0 ? true : false
                              }
                              className="form-control"
                              value={state.etype}
                              onChange={(e) => {
                                // setState({ etype: e?.target.value })
                                const new_etype = e?.target?.value;
                                if (new_etype) {
                                  setState((x: any) => ({
                                    ...x,
                                    etype: new_etype,
                                  }));
                                }
                                // setState((x: any) => ({ ...x, etype: e?.target.value }))
                              }}
                            >
                              <option value="regular">Ordinary </option>
                              <option value="capstone">Journal </option>
                            </select>
                          </div>
                        </>
                      )}

                      {/* Week No Input */}
                      {state.istimed == 0 ? (
                        <div className="col-md-4 mt-4 align-items-center align-content-center align-self-center">
                          <label
                            className="align-self-center mt-1 ml-1"
                            htmlFor="timed"
                          >
                            Timed: &nbsp;
                          </label>
                          <input
                            type="checkbox"
                            name="timed"
                            className="align-self-start"
                            checked={state.istimed == 0 ? false : true}
                            id="timed"
                            onChange={(e) => {
                              // setState({
                              //     istimed: e.target.checked == false ? 0 : 1,
                              // });
                              // setState((x: any) => ({ ...x, istimed: e.target.checked == false ? 0 : 1 }))
                              {
                                const new_istimed = e?.target?.checked;
                                if (new_istimed) {
                                  setState((x: any) => ({
                                    ...x,
                                    istimed: new_istimed,
                                  }));
                                }
                              }
                            }}
                          />
                        </div>
                      ) : (
                        <React.Fragment>
                          <div className="col-md-4 mt-4 align-items-center align-content-center align-self-center">
                            <label
                              className="align-self-center mt-1 ml-1"
                              htmlFor="timed"
                            >
                              Timed: &nbsp;
                            </label>
                            <input
                              type="checkbox"
                              name="timed"
                              className="align-self-start"
                              checked={state.istimed == 0 ? false : true}
                              id="timed"
                              onChange={(e) => {
                                // setState({
                                //     istimed: e.target.checked == false ? 0 : 1,
                                // });
                                let timed = e.target.checked;
                                setState((x: any) => ({
                                  ...x,
                                  istimed: timed == false ? 0 : 1,
                                }));
                              }}
                            />
                          </div>

                          <div className="col-md-4 mt-2 align-items-start align-content-start mx-auto">
                            <label
                              className="align-self-start mt-1 ml-1"
                              htmlFor="duration"
                            >
                              Duration: (minutes) &nbsp;
                            </label>
                            <input
                              type="number"
                              min={1}
                              className="form-control"
                              name="duration"
                              id="duration"
                              value={state.duration == 0 ? "" : state.duration}
                              onChange={(e: any) =>
                                // setState({ duration: e.target.value })
                                // setState((x: any) => ({ ...x, duration: e.target.value }))
                                {
                                  const new_duration = e?.target?.value;
                                  if (new_duration) {
                                    setState((x: any) => ({
                                      ...x,
                                      duration: new_duration,
                                    }));
                                  }
                                }
                              }
                            />
                          </div>
                        </React.Fragment>
                      )}

                      {!user?.isExternalUser && (
                        <>
                          <div className="col-md-4 mt-4 align-items-center align-content-center align-self-center ">
                            <label
                              className="align-self-center mt-1 ml-1"
                              htmlFor="ismandatory"
                            >
                              Mandatory :{" "}
                            </label>
                            <input
                              type="checkbox"
                              name="ismandatory"
                              className="align-self-start ml-1"
                              checked={state.ismandatory == 0 ? false : true}
                              id="ismandatory"
                              onChange={(e) => {
                                const new_ismandatory: any = e?.target?.checked;
                                setState((x: any) => ({
                                  ...x,
                                  ismandatory: new_ismandatory,
                                }));
                              }}
                            />
                          </div>
                          <div className="col-md-4 mt-4 align-items-center align-content-center align-self-center ">
                            <label
                              className="align-self-center mt-1 ml-1"
                              htmlFor="isprivate"
                            >
                              Private :{" "}
                            </label>
                            <input
                              type="checkbox"
                              name="isprivate"
                              className="align-self-start ml-1"
                              checked={state.isprivate == 0 ? false : true}
                              id="isprivate"
                              onChange={(e) => {
                                const new_isprivate: any = e?.target?.checked;
                                setState((x: any) => ({
                                  ...x,
                                  isprivate: new_isprivate,
                                }));
                              }}
                            />
                          </div>
                        </>
                      )}

                      <div className="col-md-4 mt-4 align-items-center align-content-center align-self-center ">
                        <label
                          className="align-self-center mt-1 ml-1"
                          htmlFor="secured"
                        >
                          Secured: &nbsp;
                        </label>

                        <input
                          type="checkbox"
                          name="secured"
                          className="align-self-start"
                          checked={state.issecured == 0 ? false : true}
                          id="secured"
                          onChange={(e) => {
                            const new_issecured: any = e?.target?.checked;
                            let tempQuestions = [...state.questions];
                            if (new_issecured == 1) {
                              tempQuestions = tempQuestions.filter(
                                (q: any) =>
                                  q.type !== "FileUploadEnhanced" &&
                                  q.type !== "ImageHighlight" &&
                                  q.type !== "ProcessCard" &&
                                  q.type !== "ProductCard"
                              );
                              setState((x: any) => ({
                                ...x,
                                issecured: new_issecured,
                                questions: tempQuestions,
                              }));
                            } else {
                              setState((x: any) => ({
                                ...x,
                                issecured: new_issecured,
                              }));
                            }
                          }}
                        />
                      </div>

                      {/* Advanced Options Dropdown */}
                      <div className="col-12 mt-3">
                        <button
                          type="button"
                          className="btn btn-link p-0 text-white"
                          onClick={() =>
                            setShowAdvancedOptions(!showAdvancedOptions)
                          }
                        >
                          <i
                            className={`fas ${
                              showAdvancedOptions
                                ? "fa-chevron-up"
                                : "fa-chevron-down"
                            }`}
                          ></i>
                          &nbsp;Advanced Options
                        </button>

                        {showAdvancedOptions && (
                          <div className="row mt-2">
                            <div className="col-md-4 mt-2 row align-items-start align-content-start mx-auto">
                              <label
                                className="align-self-start ml-1 "
                                htmlFor="returnResultTo"
                              >
                                Return Result To: &nbsp;
                              </label>
                              <input
                                id="returnResultTo"
                                name="returnResultTo"
                                type="url"
                                className="form-control"
                                value={state?.returnResultTo || ""}
                                onChange={(e) => {
                                  const returnResultTo = e?.target?.value;
                                  setState((x: any) => ({
                                    ...x,
                                    returnResultTo,
                                  }));
                                }}
                              />
                            </div>

                            {/* API Documentation Section */}
                            <div className="col-12 mt-3">
                              <div className="bg-dark rounded p-3 border border-secondary">
                                <h6 className="text-warning mb-2">
                                  <i className="fas fa-info-circle mr-2"></i>
                                  API Integration Information
                                </h6>
                                <p className="text-light mb-3">
                                  If you enter an API link above, the exam
                                  results will be automatically posted to it
                                  upon grading and user submissions.
                                </p>

                                <h6 className="text-warning mb-2">
                                  Expected Data Format:
                                </h6>
                                <div className="bg-secondary rounded p-3">
                                  <pre
                                    className="text-light mb-0"
                                    style={{
                                      fontSize: "12px",
                                      whiteSpace: "pre-wrap",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    {`{
  "id": "",
  "exam_id": "",
  "student_id": "",
  "group_id": null,
  "status": "",
  "submitdate": "",
  "releasedate": "",
  "istimed": "",
  "exam_name": "",
  "submit_date": null,
  "studentstartdate": "",
  "total_score": "",
  "outof": "",
  "issecured": "",
  "version": "",
  "subject_id": null,
  "answeredquestions": "[]",
  "usertype": null,
  "questions": null,
  "last_updated": null,
  "current_signed_user_email": "",
  "invited_user_email": ""
}`}
                                  </pre>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      {state.issecured == 1 && (
                        <div className="text-center w-100 mt-2">
                          <span className="text-danger">*</span>{" "}
                          <strong
                            style={{ fontWeight: "bold", fontSize: "20px" }}
                          >
                            {" "}
                            Please note that questions requiring file uploads or
                            access to camera or microphone will not be available
                            in a secured exam.{" "}
                          </strong>
                        </div>
                      )}
                    </div>

                    <button
                      className="btn btn-success ml-3 mt-3"
                      onClick={() => {
                        onOpenPassageModal();
                      }}
                    >
                      Add passage
                    </button>
                    <h5 className="text-shadow mt-2 ml-3">
                      Passages : {state.passages?.length}
                    </h5>
                    {state.passages?.map((passage: any, index: any) => {
                      return (
                        <div
                          className="row  mx-auto align-items-center"
                          key={index}
                        >
                          <div className="col-lg-6 mt-2 ">
                            <div
                              className="bg-white text-dark rounded align-items-center mt-1 pl-5 "
                              dangerouslySetInnerHTML={{
                                __html:
                                  `<p>Passage${index + 1}-&nbsp;</p>` +
                                  passage.header,
                              }}
                            ></div>
                          </div>
                          <div className="mt-1 col-lg-4 ">
                            {
                              <Select
                                menuPortalTarget={document.body}
                                isMulti
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                                name="selectedcourse"
                                options={state.questions
                                  ?.filter(
                                    (q: any) =>
                                      !state.all_selected_passages_questions
                                        .map((c: any) => c.value)
                                        .includes(q.id)
                                  )
                                  .map((question: any) => {
                                    return {
                                      value: question.id,
                                      label: `${htmlToText(
                                        question.header
                                      ).substring(0, 200)}`, // Store plain text
                                    };
                                  })}
                                value={passage.selectedQuestions}
                                onChange={(e: any) => {
                                  let tempPassages = [...state.passages];
                                  let foundPassageIndex =
                                    tempPassages.findIndex(
                                      (p) => p.id == passage.id
                                    );
                                  if (foundPassageIndex != -1) {
                                    tempPassages[
                                      foundPassageIndex
                                    ].selectedQuestions = e;
                                  }
                                  let temp_all_selected_passages_questions: any =
                                    e?.length ? [...e] : [];
                                  tempPassages.forEach((passage: any) => {
                                    if (passage.selectedQuestions)
                                      temp_all_selected_passages_questions = [
                                        ...temp_all_selected_passages_questions,
                                        ...passage.selectedQuestions,
                                      ];
                                  });

                                  setState((x: any) => ({
                                    ...x,
                                    open: false,
                                    passages: tempPassages,
                                    all_selected_passages_questions:
                                      temp_all_selected_passages_questions,
                                  }));
                                }}
                                className="basic-multi-select text-dark"
                                classNamePrefix="select"
                                placeholder="Select passage questions "
                              />
                            }
                          </div>
                          <div className="col-md-3 col-lg-1 mt-2">
                            <button
                              type="button"
                              onClick={() => {
                                onOpenPassageModal(passage);
                                // setState({ open: true });
                                setState((x: any) => ({ ...x, open: true }));
                              }}
                              className="btn btn-block text-white btn-warning mt-1"
                            >
                              Edit
                            </button>
                          </div>
                          <div className="col-md-3 col-lg-1 mt-2">
                            <button
                              type="button"
                              className="btn btn-block text-white btn-danger mt-1"
                              onClick={() => DeletePassage(passage.id)}
                            >
                              Delete
                            </button>
                          </div>
                        </div>
                      );
                    })}

                    <h5 className="text-shadow mt-2 ml-3 mt-3">
                      Total Marks :{" "}
                      {state.questions?.reduce(
                        (sum: any, item: any) => sum + +item.total_mark,
                        0
                      )}
                    </h5>
                    <h5 className="text-shadow mt-2 ml-3 mt-3">
                      Questions : {state.questions?.length}
                      <br />
                    </h5>
                    <DragDropContext
                      onDragEnd={(param) => {
                        onDrop(param.source.index, param.destination?.index);
                      }}
                    >
                      <Droppable droppableId="drop1">
                        {(provieded, snapshot) => {
                          return (
                            <div
                              className="col-12"
                              ref={provieded.innerRef}
                              {...provieded.droppableProps}
                            >
                              {state.questions?.map((q: any, index: number) => {
                                return (
                                  <Draggable
                                    draggableId={`draggable-${q.id}`}
                                    index={index}
                                    key={q.id}
                                  >
                                    {(provieded, snapshot) => (
                                      <div
                                        className="row mt-4  mx-auto align-items-center"
                                        key={index}
                                        ref={provieded.innerRef}
                                        {...provieded.draggableProps}
                                        {...provieded.dragHandleProps}
                                      >
                                        <i
                                          className="fa-solid fa-bars"
                                          style={{ cursor: "pointer" }}
                                        ></i>
                                        <div className="col-lg-9 mt-2 ">
                                          <div className="col-lg-12 mt-2 ">
                                            {/* replaced: single dangerouslySetInnerHTML block */}
                                            <div className="bg-white text-dark rounded mt-1 p-3">
                                              <div className="d-flex justify-content-between align-items-start mb-2">
                                                <div>
                                                  <strong>Q{index + 1}</strong>

                                                  <span className="text-muted ml-2">
                                                    Total mark: {q.total_mark}
                                                  </span>
                                                </div>
                                                <div>
                                                  <span className="badge badge-primary mr-1">
                                                    {q.type}
                                                  </span>
                                                  <span className="badge badge-secondary mr-1">
                                                    Difficulty:{" "}
                                                    {difficultLevelMap[
                                                      String(
                                                        q.difficult_id
                                                      ) as keyof typeof difficultLevelMap
                                                    ] || q.difficult_id}
                                                  </span>
                                                  <span className="badge badge-info">
                                                    Cognitive:{" "}
                                                    {cognitiveLevelMap[
                                                      String(
                                                        q.cognitive_id
                                                      ) as keyof typeof cognitiveLevelMap
                                                    ] || q.cognitive_id}
                                                  </span>
                                                </div>
                                              </div>

                                              <div
                                                className="question-content"
                                                dangerouslySetInnerHTML={{
                                                  __html: q.header,
                                                }}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                        <div className="col-md-3 col-lg-1 mt-2">
                                          <button
                                            type="button"
                                            onClick={() => {
                                              editQuestionsRenderer(q.type, q);
                                              // setState({ open: true });
                                              setState((x: any) => ({
                                                ...x,
                                                open: true,
                                              }));
                                            }}
                                            className="btn btn-block text-white btn-warning mt-1"
                                          >
                                            Edit
                                          </button>
                                        </div>
                                        <div className="col-md-3 col-lg-1 mt-2">
                                          <button
                                            type="button"
                                            className="btn btn-block text-white btn-danger mt-1"
                                            onClick={() => removeQuest(q)}
                                          >
                                            Delete
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                );
                              })}
                            </div>
                          );
                        }}
                      </Droppable>
                    </DragDropContext>
                  </div>

                  {/* Fixed Footer Section */}
                  <div
                    className="p-3 border-top border-secondary"
                    style={{ flexShrink: 0 }}
                  >
                    <div className="text-center">
                      <button
                        className="btn btn-warning text-white"
                        onClick={submitExam}
                        disabled={state.name?.length == 0}
                      >
                        Submit exam
                      </button>
                    </div>
                  </div>
                </div>
                <Modal
                  classNames={{
                    modal: "customModal",
                  }}
                  closeOnOverlayClick={false}
                  open={state.open}
                  onClose={() => onCloseModal()}
                  center
                >
                  {modalContent}
                  {/*QuestionsRenderer()*/}
                </Modal>
              </div>
            </div>
          </div>
        </div>
      </div>
      <MobileQuestionMenu
        issecured={state.issecured}
        onSelect={(type) => {
          QuestionsRenderer(type);
          setState((x: any) => ({ ...x, open: true }));
        }}
      />
    </MathJax>
  );
};
export default withRouter(assessmentComponent);
